// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".ygFBiL2QonhTVe3dwWdw{grid-column:1/-1}.ItrpGoi7yDdYkfPl2TZg{grid-column:1/-1}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"layoutCurrentHospital": "ygFBiL2QonhTVe3dwWdw",
	"layoutAppointmentSchedule": "ItrpGoi7yDdYkfPl2TZg"
};
export default ___CSS_LOADER_EXPORT___;
